
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { NextRoute, Project } from '@/types';

	import { mdiAccount, mdiLogoutVariant } from '@mdi/js';

	import loginService from '@/services/Security/loginService';
	import accessmasterManager from '@/services/Security/accessmasterManager';
	import currentProjectInfoService from '@/services/Navigation/currentProjectInfoService';
	import { useProjectStore } from '@/store/ProjectStore';
	import paymentStores from '@/store/PaymentStore';
	import patientStores from '@/store/PatientStore';
	import { useAppStateStore } from '@/store/modules/appStateStore';
	import { UserInfo } from '@/types';

	interface LinkItem {
		title: string;
		disabled: boolean;
		to: NextRoute;
		rule: string;
	}

	const SetUp = Vue.extend({
		setup() {
			const projectStore = useProjectStore();
			const resetPaymentStores =  () => paymentStores.reset();
			const resetPatientStores = () => patientStores.reset();

			return { projectStore, resetPaymentStores, resetPatientStores };
		}
	});

	/** The profile button in the Header */
	@Component
	export default class HeaderMenu extends SetUp {
		splitLength = 15;
		splitTimes = 0;

		// Icons
		userIcon = mdiAccount;
		logoutIcon = mdiLogoutVariant;
		appStateStore = useAppStateStore();

		get user(): UserInfo | null {
			return this.appStateStore.getUser;
		}

		get agent(): string {
			if (this.user) {
				return `${this.user.firstname} ${this.user.lastname}`;
			}

			return this.$t('components.layout.headerMenu.label') as string;
		}

		get project(): Project | null {
			return currentProjectInfoService.getCurrentProjectStore();
		}

		get links(): LinkItem[] {
			const links = this.$t('components.layout.headerMenu.links') as unknown as LinkItem[] | string;

			if ('string' === typeof links) {
				return [];
			}

			const filtered = links.filter((link) => {
				return this.$can(link.rule);
			});

			return filtered;
		}

		/** Logout the user from accessmaster or local login */
		logout() {
			this.projectStore.$reset();
			this.resetPatientStores();
			this.resetPaymentStores();

			if (accessmasterManager.isLogged()) {
				accessmasterManager.logout();

				return;
			}

			if (loginService.isLogged()) {
				loginService.logout();

				return;
			}

			this.$router.push({
				name: 'login'
			});
		}
	}
